// Shared avatar utilities — reused by MyInfoPage (self-serve) and EmployeesPage
// (manager-editing-another-user).
//
// Preserves aspect ratio: the longest side is scaled down to MAX_DIM, the
// other side scales proportionally so the resulting data URL never distorts.
// Downstream renderers should always apply `object-cover` so cropping — not
// stretching — is the fallback when a container has a different aspect ratio.

export const AVATAR_MAX_DIM = 512;
export const AVATAR_JPEG_QUALITY = 0.85;

export function resizeAvatarToDataUrl(file, { maxDim = AVATAR_MAX_DIM, quality = AVATAR_JPEG_QUALITY } = {}) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);
        const c = document.createElement("canvas");
        c.width = w; c.height = h;
        const ctx = c.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        resolve(c.toDataURL("image/jpeg", quality));
      };
      img.onerror = () => reject(new Error("Not a valid image"));
      img.src = reader.result;
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
